import React, { useEffect, useState } from 'react';
import './TransactionHistory.css';
import Sidebar from '../components/Sidebar';

interface Transaction {
  id: number;
  userId: number;
  userName: string;
  email: string;
  amount: number;
  paymentMethod: string;
  paymentGateway: string;
  currency: string;
  transactionId: string;
  orderId: string;
  paymentStatus: string;
  transactionType: string;
  refundAmount: number;
  ipAddress: string;
  adminNotes: string;
  status: string;
  date: string;
}

const TransactionHistory: React.FC = () => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);

  useEffect(() => {
    fetch("http://localhost:5000/transactions")
      .then(res => res.json())
      .then(data => setTransactions(data))
      .catch(err => console.error("Error loading transactions:", err));
  }, []);
 const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div style={{ display:'flex'}}>  <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
    <div
      style={{
        flex: 1,
        marginLeft: isSidebarOpen ? "250px" : "60px",
        transition: "margin-left 0.3s ease",
        padding: "20px"
      }}
    >
    <div className='main-content1'>
    <div className="transaction-container">
      <h2>Transaction History</h2>
      <div className="table-scroll">
        <table className="transaction-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>User</th>
              <th>Email</th>
              <th>Amount</th>
              <th>Refund</th>
              <th>Currency</th>
              <th>Payment Method</th>
              <th>Gateway</th>
              <th>Transaction ID</th>
              <th>Order ID</th>
              <th>Type</th>
              <th>Status</th>
              <th>Payment Status</th>
              <th>IP</th>
              <th>Admin Notes</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map(txn => (
              <tr key={txn.id}>
                <td>{txn.id}</td>
                <td>{txn.userName}</td>
                <td>{txn.email}</td>
                <td>{txn.amount}</td>
                <td>{txn.refundAmount}</td>
                <td>{txn.currency}</td>
                <td>{txn.paymentMethod}</td>
                <td>{txn.paymentGateway}</td>
                <td>{txn.transactionId}</td>
                <td>{txn.orderId}</td>
                <td>{txn.transactionType}</td>
                <td>{txn.status}</td>
                <td className={txn.paymentStatus.toLowerCase()}>{txn.paymentStatus}</td>
                <td>{txn.ipAddress}</td>
                <td>{txn.adminNotes}</td>
                <td>{new Date(txn.date).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div></div>
    </div></div>
    
  );
};

export default TransactionHistory;
